import { useQuery } from '@tanstack/react-query';

import { queries } from '../common/api/queryKeys/queries';

import { SupplierSubscriptionReleaseFlagsMessage } from './types/SupplierSubscriptionReleaseFlagsMessage';

const INACTIVE_RELEASE_FLAGS: SupplierSubscriptionReleaseFlagsMessage = {
    earlySubscriptionSignup: false,
    regularSubscriptionSignup: false,
    feeEnforcement: false,
};

export const useSupplierSubscriptionReleaseFlags = (enabled: boolean): SupplierSubscriptionReleaseFlagsMessage => {
    const releaseFlags = useQuery({
        ...queries.supplierSubscriptionReleaseFlags.current,
        enabled,
        throwOnError: false,
        refetchInterval: 30 * 60 * 1000,
        refetchIntervalInBackground: false,
        refetchOnWindowFocus: true,
    });

    return releaseFlags.data ?? INACTIVE_RELEASE_FLAGS;
};
